export default {
  en: {
    keyword: 'Keyword',
    name: 'Name',
    type: 'Type',
    rate: 'Price',
    unit: 'Unit',
    periodOfStay: 'Period of Stay',
    condition: 'Condition',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions',
    updatedSupplementMessage: 'This supplement has been updated',
    deletedSupplementMessage: 'This supplement has been deleted',
    allTheTime: 'All',
    UNIT_TYPE: {
      PER_PERSON: '/ Person',
      PER_ROOM: '/ Room',
      PER_BOOKING: '/ Booking',
      DISCOUNT: 'Discount',
      NOT_AVAILABLE: 'N/A'
    },
    PRICE_TYPE: {
      NET: '.-',
      PERCENT: '%',
      NOT_AVAILABLE: 'N/A'
    }
  },
  th: {
    keyword: 'คำที่ต้องการค้นหา',
    name: 'ชื่อ',
    type: 'ประเภท',
    rate: 'ราคา',
    unit: 'หน่วย',
    periodOfStay: 'ช่วงเวลา',
    condition: 'รายละเอียด',
    selectedVersion: 'ข้อมูลที่เลือก',
    latestVersion: 'ข้อมูลล่าสุด',
    updatedSupplementMessage: 'รายการเพิ่มเติมนี้มีการแก้ไข',
    deletedSupplementMessage: 'รายการเพิ่มเติมนี้ถูกลบไปแล้ว',
    allTheTime: 'ตลอดระยะสัญญา',
    UNIT_TYPE: {
      PER_PERSON: '/ คน',
      PER_ROOM: '/ ห้อง',
      PER_BOOKING: '/ บุ๊คกิ้ง',
      DISCOUNT: 'ส่วนลด',
      NOT_AVAILABLE: 'N/A'
    },
    PRICE_TYPE: {
      NET: '.-',
      PERCENT: '%',
      NOT_AVAILABLE: 'N/A'
    }
  }
}
